import { useBankProfile } from '@contexts/BankProfileContext';
import { Typography } from '@gurupay/gp-ui-library';
import type { IMessage } from '@hooks/useMessages';
import { NonBreakingDate } from '@pages/messages/NonBreakingDate';
import clsx from 'clsx';
import type { TFunction } from 'i18next';

export const MessagesRenderers = (t: TFunction) => {
	const { selectedProfile } = useBankProfile();

	return {
		messageInfo: ({ topic, last_message_at, unread_count, customer_id }: IMessage) => (
			<div className="flex w-full flex-col items-start gap-space-4 sm:flex-row sm:items-center sm:gap-space-16">
				<div className="w-full min-w-0 sm:w-0 sm:flex-1">
					<Typography
						className={clsx(
							'block whitespace-normal wrap-break-words sm:truncate',
							unread_count ? 'font-bold' : 'font-medium',
						)}
						level="small-text"
					>
						{t(`topics.${topic.value}`)}
					</Typography>

					<Typography
						className={clsx(
							unread_count
								? 'font-bold text-neutral-950'
								: 'font-medium text-neutral-800',
						)}
						level="small-text"
					>
						{selectedProfile?.id === customer_id ? selectedProfile.name : 'Guru Pay'}
					</Typography>
				</div>

				<Typography
					className={clsx(
						'shrink-0',
						unread_count ? 'font-bold text-neutral-950' : 'font-medium text-neutral-800',
					)}
					level="small-text"
				>
					<NonBreakingDate date={last_message_at} />
				</Typography>
			</div>
		),
	};
};
